import React from 'react';
import grey from '@material-ui/core/colors/grey';
import { makeStyles } from '@material-ui/core/styles';
import { PeriodDropdown } from '~/modules/common/components';
import StickyHeader from '~/modules/common/components/StickyHeader/StickyHeader';
import PeriodStartDateSelector from '~/modules/common/charts/dashboard/PeriodStartDateSelector';
import { useResourceOverviewToolbarContext } from '../../hooks';

const usePeriodDropdownStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(0, 2, 0, 0)
  }
}));

const useStyles = makeStyles(() => ({
  spacer: {
    flexGrow: 1,
    flexShrink: 1
  }
}));

export const useStickyHeaderStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1)
  },
  toolbar: {
    backgroundColor: grey[50]
  }
}));

export const ResourcingOverviewToolbar = () => {
  const {
    dateRange,
    periodScale,
    setScale,
    setNextPeriod,
    setPreviousPeriod,
    setDate
  } = useResourceOverviewToolbarContext();

  const classes = useStyles();
  const stickyHeaderStyles = useStickyHeaderStyles();
  const periodClasses = usePeriodDropdownStyles();

  return (
    <StickyHeader level={2} classes={stickyHeaderStyles}>
      <PeriodStartDateSelector
        onPreviousClick={setPreviousPeriod}
        onNextClick={setNextPeriod}
        dateRange={dateRange}
        scale={periodScale}
        setDate={setDate}
      />
      <div className={classes.spacer} />
      <PeriodDropdown
        classes={periodClasses}
        value={periodScale}
        onChange={setScale}
        showYears={false}
      />
    </StickyHeader>
  );
};

export default ResourcingOverviewToolbar;
